import { LocalPrinterSettings } from './LocalPrinterSettings'

export default LocalPrinterSettings
